import React from 'react';
import RoleButton from './RoleButton';
import LocalStorageService from '../../services/utilities/LocalStorageService';
import { isTargetRoleId } from '../../utilities/roleUtility';
import { USER_ROLES } from '../../utilities/constants';

/**
 * @description 元請ユーザー(本社管理者、支店管理者、現場監督)、
 *              協力会社管理者専用ボタン
 */
const PrimeContractorToPartnerButton = props => (
  <RoleButton
    label={props.label}
    buttonClass={props.buttonClass}
    onClick={props.onClick}
    show={isTargetRoleId(
      [
        USER_ROLES.prime,
        USER_ROLES.branch,
        USER_ROLES.manager,
        USER_ROLES.partner,
      ],
      LocalStorageService.getRoleId()
    )}
  />
);

export default PrimeContractorToPartnerButton;



// WEBPACK FOOTER //
// ./src/components/button/PrimeContractorToPartnerButton.jsx